var map = {
	"./AgentAssist/bot.png": 78712,
	"./agentassistlogin/bot.png": 12764,
	"./bcx/bot.png": 53953,
	"./blueoak/bot.png": 45521,
	"./default/bot.png": 33317,
	"./eskom/bot.png": 3136,
	"./momentum/bot.png": 28770,
	"./tigerbrands/bot.png": 47042,
	"./tongaat/bot.png": 38020,
	"./xib-demo/bot.png": 10785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54239;